// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * cwan-ux: shared ag-grid theme — cwan palette hex (light + dark).
 * Applied via \`ag-theme-cwan\` on \`ag-theme-quartz\` / \`ag-theme-quartz-dark\`.
 * Single source of truth for grid theming.
 */

.ag-theme-quartz.ag-theme-cwan,
.ag-theme-quartz-dark.ag-theme-cwan {
  --ag-active-color: #0a5eb2;
  --ag-background-color: #ffffff;
  --ag-border-color: #e5e5e5;
  --ag-border-radius: 8px;
  --ag-cell-horizontal-border: none;
  --ag-cell-horizontal-padding: 12px;
  --ag-data-color: #363636;
  --ag-font-family: 'Noto Sans', sans-serif;
  --ag-font-size: 12px;
  --ag-foreground-color: #363636;
  --ag-header-background-color: #fafafa;
  --ag-header-column-resize-handle-color: #e5e5e5;
  --ag-header-column-resize-handle-display: none;
  --ag-header-column-resize-handle-height: 100%;
  --ag-header-column-resize-handle-width: 1px;
  --ag-header-column-separator-color: #e5e5e5;
  --ag-header-column-separator-display: none;
  --ag-header-column-separator-height: 12px;
  --ag-header-column-separator-width: 1px;
  --ag-header-foreground-color: #363636;
  --ag-icon-font-color: #737575;
  --ag-icon-size: 14px;
  --ag-odd-row-background-color: #fafafa;
  --ag-row-border-color: #e5e5e5;
  --ag-row-border-style: solid;
  --ag-row-border-width: 1px;
  --ag-row-hover-color: transparent;
  --ag-column-hover-color: transparent;
  --ag-secondary-border-color: #e5e5e5;
  --ag-selected-row-background-color: rgba(17, 98, 231, 0.08);
  --ag-range-selection-background-color: rgba(17, 98, 231, 0.12);
  --ag-range-selection-border-color: rgba(17, 98, 231, 0.5);
  --ag-wrapper-border-radius: 8px;
}

.ag-theme-quartz.ag-theme-cwan.compact-grid,
.ag-theme-quartz-dark.ag-theme-cwan.compact-grid {
  --ag-grid-size: 5px;
  --ag-header-height: 28px;
  --ag-row-height: 20px;
}

.ag-theme-cwan .ag-root-wrapper {
  border-color: #e5e5e5;
  border-radius: 8px;
}

.ag-theme-cwan .ag-header,
.ag-theme-cwan .ag-pinned-left-header {
  background-color: #fafafa;
}

.ag-theme-cwan .ag-header-cell,
.ag-theme-cwan .ag-cell {
  padding-left: 16px;
  padding-right: 12px;
}

.ag-theme-cwan .ag-header-cell-label {
  gap: 6px;
}

.ag-theme-cwan .ag-header-row {
  font-weight: 600;
}

.ag-theme-cwan .ag-header-cell-text {
  color: var(--ag-header-foreground-color, #363636);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 18px;
}

.ag-theme-cwan .ag-cell-value {
  color: var(--ag-data-color, #363636);
  font-size: 12px;
}

.ag-theme-cwan .ag-row-odd {
  background-color: var(--ag-odd-row-background-color, #fafafa);
}

.ag-theme-cwan .ag-row-odd .ag-cell {
  background-color: var(--ag-odd-row-background-color, #fafafa);
}

.ag-theme-cwan .ag-pinned-left-header,
.ag-theme-cwan .ag-pinned-left-cols-container,
.ag-theme-cwan .ag-pinned-left-floating-bottom {
  border-right: 1px solid #e5e5e5;
  box-shadow:
    12px 0px 16px -12px rgba(10, 13, 18, 0.08),
    4px 0px 6px -4px rgba(10, 13, 18, 0.03),
    1px 0px 2px -1px rgba(10, 13, 18, 0.04);
  z-index: 3;
}

.ag-theme-cwan .ag-floating-bottom,
.ag-theme-cwan .ag-pinned-left-floating-bottom {
  background-color: #f3f3f3;
  border-top: 1px solid #e5e5e5;
}

.ag-theme-cwan .ag-floating-bottom .ag-row,
.ag-theme-cwan .ag-pinned-left-floating-bottom .ag-row {
  background-color: #f3f3f3;
  height: 22px;
  min-height: 22px;
}

.ag-theme-cwan .ag-floating-bottom .ag-cell-value,
.ag-theme-cwan .ag-pinned-left-floating-bottom .ag-cell-value {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 18px;
}

.ag-theme-cwan .ag-body-horizontal-scroll,
.ag-theme-cwan .ag-body-vertical-scroll,
.ag-theme-cwan .ag-body-horizontal-scroll-viewport,
.ag-theme-cwan .ag-body-vertical-scroll-viewport,
.ag-theme-cwan .ag-floating-bottom-viewport {
  background-color: #f3f3f3;
  scrollbar-color: #9d9e9e #f3f3f3;
}

.ag-theme-cwan .ag-body-horizontal-scroll {
  min-height: 20px;
}

.ag-theme-cwan
  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)
  .ag-horizontal-left-spacer:not(.ag-scroller-corner),
.ag-theme-cwan
  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)
  .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  background-color: #f3f3f3;
  border-top: 1px solid #e5e5e5;
}

.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar,
.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar,
.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar {
  height: 20px;
  width: 20px;
}

.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,
.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,
.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-track {
  background-color: #f3f3f3;
}

.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,
.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,
.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-thumb {
  background-color: #9d9e9e;
  border: 4px solid #f3f3f3;
  border-radius: 16px;
}

/* Dark overrides — cwan dark palette hex */
.ag-theme-quartz-dark.ag-theme-cwan {
  --ag-active-color: #85b8fe;
  --ag-background-color: #121212;
  --ag-border-color: #3a3a3a;
  --ag-cell-horizontal-border: none;
  --ag-data-color: #e0e0e0;
  --ag-foreground-color: #e0e0e0;
  --ag-header-background-color: #242424;
  --ag-header-column-separator-color: #3a3a3a;
  --ag-header-foreground-color: #e0e0e0;
  --ag-icon-font-color: #888888;
  --ag-odd-row-background-color: #1e1e1e;
  --ag-row-border-color: #3a3a3a;
  --ag-secondary-border-color: #3a3a3a;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-header,
.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-header {
  background-color: #242424;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-header,
.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-cols-container,
.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom {
  border-right-color: #3a3a3a;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom,
.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom,
.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom .ag-row,
.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom .ag-row {
  background-color: #242424;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom,
.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom {
  border-top-color: #3a3a3a;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-row-odd,
.ag-theme-quartz-dark.ag-theme-cwan .ag-row-odd .ag-cell {
  background-color: #1e1e1e;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll,
.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll,
.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll-viewport,
.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll-viewport,
.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom-viewport {
  background-color: #1e1e1e;
  scrollbar-color: #555555 #1e1e1e;
}

.ag-theme-quartz-dark.ag-theme-cwan
  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)
  .ag-horizontal-left-spacer:not(.ag-scroller-corner),
.ag-theme-quartz-dark.ag-theme-cwan
  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)
  .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  background-color: #1e1e1e;
  border-top-color: #3a3a3a;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,
.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,
.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-track {
  background-color: #1e1e1e;
}

.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,
.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,
.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-thumb {
  background-color: #555555;
  border-color: #1e1e1e;
}
`, "",{"version":3,"sources":["webpack://./src/styles/agThemeCwan.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;EACrC,+CAA+C;EAC/C,8CAA8C;EAC9C,6CAA6C;EAC7C,2CAA2C;EAC3C,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,uCAAuC;EACvC,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,sCAAsC;EACtC,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,2DAA2D;EAC3D,8DAA8D;EAC9D,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;;EAGE,+BAA+B;EAC/B;;;2CAGyC;EACzC,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;EAKE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,qCAAqC;EACrC,2CAA2C;EAC3C,qCAAqC;EACrC,6BAA6B;EAC7B,sCAAsC;EACtC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":["/*\n * cwan-ux: shared ag-grid theme — cwan palette hex (light + dark).\n * Applied via `ag-theme-cwan` on `ag-theme-quartz` / `ag-theme-quartz-dark`.\n * Single source of truth for grid theming.\n */\n\n.ag-theme-quartz.ag-theme-cwan,\n.ag-theme-quartz-dark.ag-theme-cwan {\n  --ag-active-color: #0a5eb2;\n  --ag-background-color: #ffffff;\n  --ag-border-color: #e5e5e5;\n  --ag-border-radius: 8px;\n  --ag-cell-horizontal-border: none;\n  --ag-cell-horizontal-padding: 12px;\n  --ag-data-color: #363636;\n  --ag-font-family: 'Noto Sans', sans-serif;\n  --ag-font-size: 12px;\n  --ag-foreground-color: #363636;\n  --ag-header-background-color: #fafafa;\n  --ag-header-column-resize-handle-color: #e5e5e5;\n  --ag-header-column-resize-handle-display: none;\n  --ag-header-column-resize-handle-height: 100%;\n  --ag-header-column-resize-handle-width: 1px;\n  --ag-header-column-separator-color: #e5e5e5;\n  --ag-header-column-separator-display: none;\n  --ag-header-column-separator-height: 12px;\n  --ag-header-column-separator-width: 1px;\n  --ag-header-foreground-color: #363636;\n  --ag-icon-font-color: #737575;\n  --ag-icon-size: 14px;\n  --ag-odd-row-background-color: #fafafa;\n  --ag-row-border-color: #e5e5e5;\n  --ag-row-border-style: solid;\n  --ag-row-border-width: 1px;\n  --ag-row-hover-color: transparent;\n  --ag-column-hover-color: transparent;\n  --ag-secondary-border-color: #e5e5e5;\n  --ag-selected-row-background-color: rgba(17, 98, 231, 0.08);\n  --ag-range-selection-background-color: rgba(17, 98, 231, 0.12);\n  --ag-range-selection-border-color: rgba(17, 98, 231, 0.5);\n  --ag-wrapper-border-radius: 8px;\n}\n\n.ag-theme-quartz.ag-theme-cwan.compact-grid,\n.ag-theme-quartz-dark.ag-theme-cwan.compact-grid {\n  --ag-grid-size: 5px;\n  --ag-header-height: 28px;\n  --ag-row-height: 20px;\n}\n\n.ag-theme-cwan .ag-root-wrapper {\n  border-color: #e5e5e5;\n  border-radius: 8px;\n}\n\n.ag-theme-cwan .ag-header,\n.ag-theme-cwan .ag-pinned-left-header {\n  background-color: #fafafa;\n}\n\n.ag-theme-cwan .ag-header-cell,\n.ag-theme-cwan .ag-cell {\n  padding-left: 16px;\n  padding-right: 12px;\n}\n\n.ag-theme-cwan .ag-header-cell-label {\n  gap: 6px;\n}\n\n.ag-theme-cwan .ag-header-row {\n  font-weight: 600;\n}\n\n.ag-theme-cwan .ag-header-cell-text {\n  color: var(--ag-header-foreground-color, #363636);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 18px;\n}\n\n.ag-theme-cwan .ag-cell-value {\n  color: var(--ag-data-color, #363636);\n  font-size: 12px;\n}\n\n.ag-theme-cwan .ag-row-odd {\n  background-color: var(--ag-odd-row-background-color, #fafafa);\n}\n\n.ag-theme-cwan .ag-row-odd .ag-cell {\n  background-color: var(--ag-odd-row-background-color, #fafafa);\n}\n\n.ag-theme-cwan .ag-pinned-left-header,\n.ag-theme-cwan .ag-pinned-left-cols-container,\n.ag-theme-cwan .ag-pinned-left-floating-bottom {\n  border-right: 1px solid #e5e5e5;\n  box-shadow:\n    12px 0px 16px -12px rgba(10, 13, 18, 0.08),\n    4px 0px 6px -4px rgba(10, 13, 18, 0.03),\n    1px 0px 2px -1px rgba(10, 13, 18, 0.04);\n  z-index: 3;\n}\n\n.ag-theme-cwan .ag-floating-bottom,\n.ag-theme-cwan .ag-pinned-left-floating-bottom {\n  background-color: #f3f3f3;\n  border-top: 1px solid #e5e5e5;\n}\n\n.ag-theme-cwan .ag-floating-bottom .ag-row,\n.ag-theme-cwan .ag-pinned-left-floating-bottom .ag-row {\n  background-color: #f3f3f3;\n  height: 22px;\n  min-height: 22px;\n}\n\n.ag-theme-cwan .ag-floating-bottom .ag-cell-value,\n.ag-theme-cwan .ag-pinned-left-floating-bottom .ag-cell-value {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  line-height: 18px;\n}\n\n.ag-theme-cwan .ag-body-horizontal-scroll,\n.ag-theme-cwan .ag-body-vertical-scroll,\n.ag-theme-cwan .ag-body-horizontal-scroll-viewport,\n.ag-theme-cwan .ag-body-vertical-scroll-viewport,\n.ag-theme-cwan .ag-floating-bottom-viewport {\n  background-color: #f3f3f3;\n  scrollbar-color: #9d9e9e #f3f3f3;\n}\n\n.ag-theme-cwan .ag-body-horizontal-scroll {\n  min-height: 20px;\n}\n\n.ag-theme-cwan\n  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)\n  .ag-horizontal-left-spacer:not(.ag-scroller-corner),\n.ag-theme-cwan\n  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)\n  .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\n  background-color: #f3f3f3;\n  border-top: 1px solid #e5e5e5;\n}\n\n.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar,\n.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar,\n.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar {\n  height: 20px;\n  width: 20px;\n}\n\n.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,\n.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,\n.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-track {\n  background-color: #f3f3f3;\n}\n\n.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,\n.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,\n.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-thumb {\n  background-color: #9d9e9e;\n  border: 4px solid #f3f3f3;\n  border-radius: 16px;\n}\n\n/* Dark overrides — cwan dark palette hex */\n.ag-theme-quartz-dark.ag-theme-cwan {\n  --ag-active-color: #85b8fe;\n  --ag-background-color: #121212;\n  --ag-border-color: #3a3a3a;\n  --ag-cell-horizontal-border: none;\n  --ag-data-color: #e0e0e0;\n  --ag-foreground-color: #e0e0e0;\n  --ag-header-background-color: #242424;\n  --ag-header-column-separator-color: #3a3a3a;\n  --ag-header-foreground-color: #e0e0e0;\n  --ag-icon-font-color: #888888;\n  --ag-odd-row-background-color: #1e1e1e;\n  --ag-row-border-color: #3a3a3a;\n  --ag-secondary-border-color: #3a3a3a;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-header,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-header {\n  background-color: #242424;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-header,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-cols-container,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom {\n  border-right-color: #3a3a3a;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom .ag-row,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom .ag-row {\n  background-color: #242424;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-pinned-left-floating-bottom {\n  border-top-color: #3a3a3a;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-row-odd,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-row-odd .ag-cell {\n  background-color: #1e1e1e;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll-viewport,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll-viewport,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom-viewport {\n  background-color: #1e1e1e;\n  scrollbar-color: #555555 #1e1e1e;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan\n  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)\n  .ag-horizontal-left-spacer:not(.ag-scroller-corner),\n.ag-theme-quartz-dark.ag-theme-cwan\n  .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible)\n  .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\n  background-color: #1e1e1e;\n  border-top-color: #3a3a3a;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-track {\n  background-color: #1e1e1e;\n}\n\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,\n.ag-theme-quartz-dark.ag-theme-cwan .ag-floating-bottom-viewport::-webkit-scrollbar-thumb {\n  background-color: #555555;\n  border-color: #1e1e1e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
